import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import {
  Button,
  Modal,
} from 'ui/components'

import { PANEL_ENVS } from 'utils/constants/environments'

import PlanList from 'ui/components/plan/PlanList'

import styles from './styles'

export default ({
  disabled = false,
  docType,
  filterVisibleToOrganization,
  onSelectPlan,
  showBtnCreate,
  showBtnDelete,
  showBtnEdit,
  showBtnSelect,
  showBtnView,
  toOrganization = false,
}) => {
  const classes = styles()

  const orgConfig = useSelector((state) => state.organization.config)

  let config = null
  if (toOrganization === true) {
    config = orgConfig
  } else {
    const userConfig = useSelector((state) => state.user.config)
    config = orgConfig.use_plan === true
      ? orgConfig
      : userConfig
  }

  let planDefault = null
  switch (docType) {
    case PANEL_ENVS.CPF:
      planDefault = config.default_plan_cpf
      break
    case PANEL_ENVS.CNPJ:
      planDefault = config.default_plan_cnpj
      break
    default:
  }

  const [modalOpen, setModalOpen] = useState(false)
  const [planSelected, setPlanSelected] = useState(planDefault)

  const handleToggleModal = () => {
    setModalOpen(!modalOpen)
  }

  const handleClose = () => {
    setModalOpen(false)
  }

  const handleSelectPlan = (plan) => {
    setPlanSelected(plan)
    onSelectPlan(plan)
    handleClose()
  }

  const renderPlanList = () => {
    return (
      <PlanList
        docType={docType}
        onSelectPlan={handleSelectPlan}
        showBtnCreate={showBtnCreate}
        showBtnDelete={showBtnDelete}
        showBtnEdit={showBtnEdit}
        showBtnSelect={showBtnSelect}
        showBtnView={showBtnView}
        visibleToOrganization={filterVisibleToOrganization}
      />
    )
  }

  const renderBtnText = () => {
    if (_.isEmpty(planSelected)) return 'Selecionar Plano'

    return `Plano selecionado: ${planSelected.name}`
  }

  const renderContent = () => {
    return (
      <div className={classes.contentContainer}>
        {renderPlanList()}
      </div>
    )
  }

  return (
    <div>
      <Button
        variant="outlined"
        size="small"
        onClick={handleToggleModal}
        disabled={disabled}
      >
        {renderBtnText()}
      </Button>

      <Modal
        title="Planos"
        open={modalOpen}
        onClose={handleClose}
      >
        {renderContent()}
      </Modal>
    </div>
  )
}
